const _auto = "auto"
const _square = "1 / 1"
const _video = "16 / 9"
const config = { "auto": _auto, "square": _square, "video": _video,  }
export { config as default, _auto, _square, _video }